import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { ThunkDispatch } from 'redux-thunk';

import type { AppActions } from '../actions/types';
import type { AppState } from '../reducers';

export type AppDispatch = ThunkDispatch<AppState, unknown, AppActions>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
